import React from 'react'

import { useFormContext } from 'react-hook-form'

import styled, { css } from 'styled-components'

interface IInputContainerProps {
  hasError: boolean
  rounded?: boolean
}

export interface IProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string
  label: string
  rounded?: boolean
  err?: string
}

const Textarea: React.FC<IProps> = ({
  label,
  name,
  err,
  rounded,
  ...otherProps
}) => {
  const { register, watch } = useFormContext()

  const value = watch(name)

  return (
    <InputGroup rounded={rounded} hasError={!!err}>
      <textarea className="form-input" {...otherProps} {...register(name)} />
      {label ? (
        <label
          htmlFor={name}
          className={`${
            value?.toString().length ? 'shrink' : ''
          } form-input-label`}
        >
          {label}
        </label>
      ) : null}
    </InputGroup>
  )
}

export default Textarea

const shrinkLabel = css`
  left: 3rem;
  top: 0.4rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.fonts.primary};
`
export const InputGroup = styled.div<IInputContainerProps>`
  margin: 2rem 0 1rem;
  position: relative;
  border: ${({ theme, hasError }) =>
    hasError ? `red` : `${theme.colors.secondary}`};
  border-radius: ${({ rounded }) => (rounded ? '2.5rem' : '.1rem')};
  .form-input {
    position: relative;
    background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.fonts.primary};

    font-size: 1.8rem;
    padding: 2rem 0.5rem 0 3rem;
    display: block;
    width: 100%;
    height: 100%;
    margin: 2rem 0 0;
    font-family: inherit;
    border: none;
    resize: none;

    &:focus {
      outline: none;
    }
    &:focus ~ .form-input-label {
      ${shrinkLabel}
    }
  }

  .form-input-label {
    color: ${({ theme }) => theme.fonts.primary};
    font-size: 1.8rem;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 3rem;
    top: 1.3rem;
    transition: 300ms ease all;
    &.shrink {
      ${shrinkLabel}
    }
  }
`
